import { postAudit } from "services/analitycs";
import { auditTypes } from "utils/commons";

// Bug fix: this used to POST {action, ...payload} directly - no `type`,
// no `path`. The backend's AuditDto requires both (`type` is
// @IsEnum(AuditType), `path` is @IsNotEmpty()), so every one of these
// calls was silently 400ing (caught by the .catch() below, so nothing
// user-facing broke, but no chat audit event was ever actually recorded).
// Every other feature in the app reaches POST /api/audit the same way:
// react-tracking's trackEvent({type, ...}) bubbles to App.js's root
// dispatch, which runs prepareData ({type, path, ...rest} ->
// {type, path, payload: rest}) before calling postAudit. Chat doesn't go
// through that hook/dispatch plumbing (its call sites are plain function
// calls, not components wired into a <Track> tree), so this reproduces
// prepareData's exact output shape by hand instead, keeping call sites'
// existing trackEvent(action, payload) signature unchanged.
const CHAT_EVENT_TYPES = {
  CHAT_SEND_MESSAGE: auditTypes.ACTION,
  CHAT_APPLY_FILTERS: auditTypes.ACTION,
  CHAT_LOAD_MORE_RESULTS: auditTypes.ACTION,
  CHAT_BOOKMARK_ALL: auditTypes.ACTION,
  CHAT_COPY_MESSAGE: auditTypes.ACTION,
  CHAT_TILE_VIEW: auditTypes.ACTION,
  CHAT_RESET_SESSION: auditTypes.ACTION,
  CHAT_OPEN_DOCUMENT: auditTypes.CONTENT,
  CHAT_TOGGLE_BOOKMARK: auditTypes.ACTION,
  CHAT_DOWNLOAD_BOOKMARKS: auditTypes.DOWNLOAD,
  CHAT_COPY_TRANSCRIPT: auditTypes.ACTION,
  CHAT_SUBMIT_RATING: auditTypes.ACTION,
};

// Best-effort audit trail for the chat feature, reusing the existing
// POST /audit endpoint via services/analitycs.js. Never throws: tracking
// must never break the actual user-facing action it's attached to.
const trackEvent = (action, payload = {}) => {
  const type = CHAT_EVENT_TYPES[action] || auditTypes.ACTION;
  Promise.resolve(
    postAudit({
      type,
      path: window.location.pathname || " ",
      payload: { action, ...payload },
    })
  ).catch(e => {
    console.log("Error tracking chat event", action, e);
  });
};

export default trackEvent;
